import React, { useContext } from "react";
import { Select, Card, Col, Row, DatePicker, Empty } from "antd";
import { statusList } from "../../utils";
import { ChannelCategoryFilter } from "./components/Sale/ChannelCategoryFilter";
import { LocationFilter } from "./components/Sale/LocationFilter";
import { LastOrders } from "./components/Sale/LastOrders";
import { ClosingChannel } from "./components/Sale/ClosingChannel";
import { OrdersContext } from "../../context/OrdersContext";
import { CardStatistic } from "./components/Sale/CardStatistic";
import { useOrderPercentage } from "../../utils/index";

const { Option } = Select;
const { RangePicker } = DatePicker;

const dateFormat = "DD-MM-YYYY";

const statusOptions = statusList ? Object.keys(statusList) : [];

const BoardSaleOne = () => {

  const {
    dataOrders,
    statusFilter,
    dateFilter,
    filteredOrdersByStart,
    totalSalesForDateRange,
    isLoadingSales,
    isLoadingOrders,
    isLoadingDateFilteredData,
    setStatusFilter,
    setDateFilter
  } = useContext(OrdersContext);

  const totalSales = filteredOrdersByStart?.reduce(
    (accumulator, current) => accumulator + current.saleAmount,
    0
  );


  const displayPercentage = useOrderPercentage(filteredOrdersByStart, totalSalesForDateRange);

  const totalProducts = filteredOrdersByStart?.reduce(
    (accumulator, current) =>
      accumulator +
      current.products?.reduce((total, item) => total + item.quantity, 0),
    0
  );

  // eslint-disable-next-line
  const averageSale = (totalSales / totalProducts).toFixed(2);

  // eslint-disable-next-line
  const averageProductsPerOrder =
    filteredOrdersByStart?.length > 0 ? (totalProducts / filteredOrdersByStart?.length).toFixed(2) : 0;

  const isLoading =
    isLoadingSales || isLoadingOrders || isLoadingDateFilteredData;

  if (isLoading) {
    return (
      <div className="mt-10 ml-5">Cargando Ventas...</div>
    );
  } else {
    return (
      <div className="flex justify-center h-fit">
        <div className="grid-rows-custom grid-cols-custom gap-x-0 gap-y-0 m-5 w-full xl:w-11/12">
          <div>
            <div
              className="flex justify-end"
            >
              <div className="mr-5 w-80 pb-4">
                <RangePicker
                  value={dateFilter}
                  onChange={(dates) => setDateFilter(dates)}
                  format={dateFormat}
                />
              </div>
              <div>
                <Select
                  mode="multiple"
                  value={
                    statusFilter.length ? statusFilter : ["Todos los estados"]
                  }
                  onChange={(value) => {
                    if (
                      value.includes("Todos los estados") &&
                      statusFilter.length === 1
                    ) {
                      setStatusFilter(["Todos los estados"]);
                    } else {
                      setStatusFilter(
                        value.filter((item) => item !== "Todos los estados")
                      );
                    }
                  }}
                  style={{ minWidth: 200 }}
                >
                  <Option disabled value="Todos los estados">
                    Todos los estados
                  </Option>
                  {statusOptions?.map((option) => (
                    <Option key={option} value={option}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <CardStatistic 
          data={filteredOrdersByStart} 
          dateFilteredData={filteredOrdersByStart} 
          totalSales={totalSales} 
          dataOrders={filteredOrdersByStart} 
          totalProducts={totalProducts} 
          averageSale={averageSale} 
          percentage={displayPercentage} 
          averageProductsPerOrder={averageProductsPerOrder} 
          />
          <div className="py-4 h-fit">
            <Row gutter={16} className="flex flex-col lg:flex-row">
              <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={12}>
                {filteredOrdersByStart?.length > 0 ? (
                  <ClosingChannel data={filteredOrdersByStart} />
                ) : (
                  <Card title="Canales de cierre">
                    <div
                      className="h-72 flex justify-center items-center"
                    >
                      <Empty description="No hay datos disponibles" />
                    </div>
                  </Card>
                )}
              </Col>
              <Col className="pb-0" xs={24} sm={24} md={24} lg={24} xl={12}>
                <Card bodyStyle={{ display: "none" }} className="h-fit" title="Ultimas ordenes" cover={<LastOrders data={dataOrders} />} />
              </Col>
            </Row>
          </div>
          <div>
            <Row gutter={16} className="flex flex-col xl:flex-row">
              <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={12}>
                <Card bodyStyle={{ display: "none" }} bordered={true} cover={<LocationFilter data={filteredOrdersByStart} />} />
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                <Card bodyStyle={{ display: "none" }} bordered={true} cover={<ChannelCategoryFilter data={filteredOrdersByStart} />} />
              </Col>
            </Row>
          </div>

        </div>
      </div>
    );
  }
};

export default BoardSaleOne;
